import React from 'react'
import './index.css'

const JobTileSkeleton = ({fill}) => {
    return (
        <div className='job-tile-skeleton' style={{width: fill && "100%"}}>
            <div className="job-location-skeleton skeleton" />
            <div className='job-title-skeleton skeleton' />
            <div className='job-description-skeleton skeleton' />
            <div className='job-description-skeleton skeleton' />
            <div className='job-description-skeleton skeleton' />
            <div className='job-description-skeleton skeleton' />
            <div style={{ flex: 1 }} />
            <div className='job-description-skeleton skeleton' />
        </div>
    )
}

export default JobTileSkeleton